const eventViewAccessoriesListing = (params, category, type) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `productImpression`,
      eventCategory: `ecommerce ${type}`,
      eventLabel: `${category?.toLowerCase()}`,
      ecommerce: {
        impressions: params,
      },
    });
  }
};

export default eventViewAccessoriesListing;
